/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for tableType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="tableType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="TABLE"/&gt; &lt;enumeration value="VIEW"/&gt; &lt;enumeration value="SYSTEM_TABLE"/&gt; &lt;enumeration value="GLOBAL_TEMPORARY"/&gt; &lt;enumeration value="LOCAL_TEMPORARY"/&gt; &lt;enumeration value="ALIAS"/&gt; &lt;enumeration value="SYNONYM"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class TableType extends Enum{

	/**
	 * Specifies the table as a table.
	 */
	static  TABLE = TableType.newLiteral("TABLE");

	/**
	 * Specifies the table as a view.
	 */
	static  VIEW = TableType.newLiteral("VIEW");

	static  SYSTEM_TABLE = TableType.newLiteral("SYSTEM_TABLE");

	static  GLOBAL_TEMPORARY = TableType.newLiteral("GLOBAL_TEMPORARY");

	static  LOCAL_TEMPORARY = TableType.newLiteral("LOCAL_TEMPORARY");

	static  ALIAS = TableType.newLiteral("ALIAS");

	static  SYNONYM = TableType.newLiteral("SYNONYM");



	value() {
		return this.name();
	}

	static fromValue(v) {
		return TableType.valueOf(v);
	}

	getResourceId() {
		return (("TableType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/TableType.js